if (!customElements.get("td-variant-select")) {
  class TdVariantSelect extends HTMLElement {
    constructor() {
      super();
      this.usesSelect = false;
    }

    connectedCallback() {
      this.initVariantListeners();
      this.setDefaultVariant();
    }

    initVariantListeners() {
      const variantInputs = this.querySelectorAll('input[type="radio"][data-variant-id]');
      const variantSelect = this.querySelector('#td-dvs__variant-selector');


      if (!variantInputs.length) {
        if (variantSelect) {
          this.usesSelect = true;
        } else {
          console.warn("No variant inputs found.");
          return;
        }
      }

      if (this.usesSelect) {
        this.selectDefault(variantSelect);
        variantSelect.addEventListener("change", (event) => {
          const selectedOption = event.target.options[event.target.selectedIndex];
          this.handleVariantChange(selectedOption);
        });
      } else {
        variantInputs.forEach((input) => {
          this.selectDefault(input);
          input.addEventListener("change", (event) => this.handleVariantChange(event.target));
          if (input.checked) {
            this.handleVariantChange(input);
          }
        }); 
      }
    }

    selectDefault(input) {
      const selectedByDefault = input.dataset.selectedByDefault;
      if (selectedByDefault === "true") {
        this.handleVariantChange(input);
      }
    }

    handleVariantChange(target) {
      this.updateUrl(target);
      this.updateAdditionalText(target);
      this.updatePrice(target);
      this.updateBadge(target);
      this.updateInventoryQuantity(target);
    }


    updateBadge(target) { 
      const badgeType = target.dataset.badgeType;
      const saleBadge = document.querySelector("[data-sale-badge]");
      const percentageSaved = target.dataset.percentageSaved;
      const amountSaved = target.dataset.amountSaved;

      if (badgeType && saleBadge) {
        if (badgeType === "percent" && percentageSaved) {
          saleBadge.textContent = percentageSaved;
        } else if (badgeType === "money" && amountSaved) {
          saleBadge.textContent = amountSaved;
        }
      }

    }

    updateInventoryQuantity(target) {
      const inventoryWrapper = document.querySelector('[data-inventory-threshold]');
      const inventoryQuantity = target.dataset.inventoryQuantity;
      const parsedInventoryQuantity = parseInt(inventoryQuantity);
      const inventoryThreshold = parseInt(inventoryWrapper.getAttribute('data-inventory-threshold'));
      const atcButton = document.querySelector('[data-atc-button]');

      if (atcButton) {
        atcButton.classList.remove("td-product__cta--disabled");
        if (!isNaN(parsedInventoryQuantity) && parsedInventoryQuantity <= 0) {
          atcButton.classList.add("td-product__cta--disabled");
        }
      }



      if (!isNaN(parsedInventoryQuantity) && parsedInventoryQuantity <= 0) {
        inventoryWrapper.id = "td-inventory__status--sold-out";
      } else if (!isNaN(parsedInventoryQuantity) && !isNaN(inventoryThreshold) && parsedInventoryQuantity < inventoryThreshold) {
        inventoryWrapper.id = "td-inventory__status--low-stock";
        const inventoryQuantityWrapper = inventoryWrapper.querySelector('[data-inventory-low-stock]');


        if (inventoryQuantityWrapper) {
          inventoryQuantityWrapper.textContent = inventoryQuantity;
        }

      } else {
        inventoryWrapper.id = "td-inventory__status--in-stock";
        const inventoryQuantityWrapper = inventoryWrapper.querySelector('[data-inventory-in-stock]')
        if (inventoryQuantityWrapper) {
          inventoryQuantityWrapper.textContent = inventoryQuantity;
        }
      }


    }


    updatePrice(target) {
      const minPrice = target.dataset.priceMin;
      const maxPrice = target.dataset.priceMax;
      const minFootage = target.dataset.footageMin;
      const maxFootage = target.dataset.footageMax;
      

      this.priceVariesFalse = document.querySelectorAll("[data-price-varies-false]");
      this.footageVariesFalse = document.querySelectorAll("[data-footage-varies-false]");
      this.priceVariesTrueMax = document.querySelectorAll("[data-price-varies-true-max]");
      this.footageVariesTrueMax = document.querySelectorAll("[data-footage-varies-true-max]");
      this.priceVariesTrueMin = document.querySelectorAll("[data-price-varies-true-min]");
      this.footageVariesTrueMin = document.querySelectorAll("[data-footage-varies-true-min]");

      const updateContent = (element, value) => {
        if (element.length > 0 && value) {
          element.forEach(el => {
            const innerNumber = el.querySelector(".td-price__inner-number");
            if (innerNumber) {
              innerNumber.textContent = value;
            }
          });
        }
      };
      
    
      updateContent(this.priceVariesFalse, minPrice);
      updateContent(this.footageVariesFalse, minFootage);
      updateContent(this.priceVariesTrueMax, maxPrice);
      updateContent(this.footageVariesTrueMax, maxFootage);
      updateContent(this.priceVariesTrueMin, minPrice);
      updateContent(this.footageVariesTrueMin, minFootage);
    }
    


    updateUrl(target) {
      const variantId = target.dataset.variantId;

      if (!variantId) return;

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      params.delete("variant");
      params.set("variant", variantId);

      const newUrl = `${url.pathname}?${params.toString()}`;
      history.replaceState({ path: newUrl }, "", newUrl);
    }

    updateAdditionalText(target) {
      const additionalText = target.dataset.variantAdditionalText;
      const additionalTextWrapper = document.querySelector("[data-additional-text]");

      if (additionalText && additionalTextWrapper) {
        const existingSpan = additionalTextWrapper.querySelector(".td-variant__additional-text");
        if (existingSpan) {
          existingSpan.remove();
        }

        const newSpan = document.createElement("span");
        newSpan.classList.add("td-variant__additional-text");
        newSpan.textContent = additionalText;

        additionalTextWrapper.appendChild(newSpan);
      }
    }

    setDefaultVariant() {
      const defaultVariantInput = this.querySelector('[data-default="true"]');
      if (defaultVariantInput) {
        defaultVariantInput.checked = true;
        this.updateUrl(defaultVariantInput);
        this.updateAdditionalText(defaultVariantInput); 
      }
    }
  }

  customElements.define("td-variant-select", TdVariantSelect);
}
